import PropTypes from "prop-types";
import React, { useState } from "react";
import Modal from "../modal-new";
import UnitInput from "../inputs/unit-input-exercise-library";
import ExtraInputComponent from "../other-exercise/ExtraInputComponent";
import { MOVEMENTS } from "../../constants";

const id = "modal-edit-primary-movement";

const EditPrimaryMovement = (
  { query, athlete, activeUserToRequest },
  { locals }
) => {
  const primary = query.modal?.primary || "squat";
  const user = athlete || activeUserToRequest;
  const primaryExercises = user.primaryExercises;
  const exercise = primaryExercises?.[primary] || {};

  const initialState = {
    videoUrl: exercise.video?.url || "",
    videoFile: null,
    videoOriginal: exercise.video?.videoOriginal || "",
    exerciseTypeField: exercise.exerciseTypeField || "",
    primaryMuscleGroup: exercise.primaryMuscleGroup || "",
    secondaryMuscleGroup: exercise.secondaryMuscleGroup || "",
    instructions: exercise.instructions || "",
    videoDeleteOtherExercise: null,
  };

  const [state, setState] = useState(initialState);

  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const cleanVideoField = () => {
    setState((prevState) => ({
      ...prevState,
      videoOriginal: "",
      videoDeleteOtherExercise: true,
    }));
  };

  const {
    videoUrl,
    videoFile,
    videoOriginal,
    exerciseTypeField,
    primaryMuscleGroup,
    secondaryMuscleGroup,
    instructions,
    videoDeleteOtherExercise,
  } = state;

  const repMax = user.repMaximums[primary];

  let proxyAthlete = "";
  if (query.athlete) {
    proxyAthlete = `?proxyAthlete=${query.athlete}`;
  }

  const formURL = `/actions/rep-maximum/update-primary${proxyAthlete}`;

  return (
    <form
      action={formURL}
      method="POST"
      data-noreset
      encType="multipart/form-data"
      id="edit-primary-exercise"
    >
      <input name="source" value="settings" type="hidden" />
      <Modal
        name={id}
        key={id}
        width="600px"
        title="Edit Primary Movement"
        className={"add-movement-modal edit"}
      >
        <div className="body">
          <div>
            <input type="hidden" name="primary" value={primary} />
            <input type="hidden" name="type" value="primary" />
            <input
              name="videoDeleteOtherExercise"
              value={videoDeleteOtherExercise}
              type="hidden"
            />

            <div>
              <div className="w-1/2 mb-6">
                <label>Name</label>
                <div className="disabled-input">{MOVEMENTS[primary]}</div>
              </div>

              <div
                className={
                  athlete ||
                  locals.pathname.includes(
                    "/dashboard/settings/exercise-library"
                  )
                    ? "column mb-6"
                    : "hidden"
                }
              >
                <div className="sub-label">1RM</div>
                <UnitInput
                  metric="kg"
                  imperial="lb"
                  className="text-input"
                  name="repMaximum"
                  placeholder="1RM"
                  defaultValue={athlete ? repMax : 100}
                />
              </div>

              <ExtraInputComponent
                videoUrl={videoUrl}
                videoFile={videoFile}
                videoOriginal={videoOriginal}
                exerciseTypeField={exerciseTypeField}
                primaryMuscleGroup={primaryMuscleGroup}
                secondaryMuscleGroup={secondaryMuscleGroup}
                instructions={instructions}
                handleInputChange={handleInputChange}
                cleanVideoField={cleanVideoField}
                form="edit-primary-exercise"
              />

              <div className="column" data-col="1/1">
                <div className="note">Movement will be saved.</div>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <a
            className="cancel force-mobile-hidden"
            href="/actions/refresh?modal="
            role="button"
            data-button-type="text-white"
            data-action="cancel"
          >
            Cancel
          </a>
          <button data-button-type="primary" type="submit">
            Save
          </button>
        </footer>
      </Modal>
    </form>
  );
};

EditPrimaryMovement.propTypes = {
  query: PropTypes.object.isRequired,
  athlete: PropTypes.object,
  activeUserToRequest: PropTypes.object.isRequired,
};
EditPrimaryMovement.contextTypes = { locals: PropTypes.object };

export { id };
export default EditPrimaryMovement;
